// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomHTML__container__pmq9t","editIcon":"CustomHTML__editIcon__3tdVY"};